// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__2Wfsn","boxTitle":"Qualiphy_boxTitle__2-Tcc","box":"Qualiphy_box__8JH5h","toggleWrap":"Qualiphy_toggleWrap__3_qHO"};